
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkEntries, fetchWorkEntriesProjectTracking } from "../store/slices/workentriesSlice";
import { fetchDescriptionTasksProjectTracking } from "../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../store/slices/employeeSlice";
import { fetchSalesHourlyRates } from "../store/slices/salesHourlyRateSlice";
import { fetchAllProjects } from "../store/slices/projectsSlice";
import { fetchQuotations } from "../store/slices/hourlyRates";
import { fetchOtherExpenses } from "../store/slices/otherexpenses";
import { fetchSalesTaxes } from "../store/slices/salesTaxesSlice";
import { fetchLeads } from "../store/slices/leadsSlice";
import { resolveEntityId } from "./salespersonRatesScope";
import { collectManagerReassignmentProjectIds } from "../pages/Operations/Projectmanager/ManagerFinance/ManagerActualAllServiceTable";




export const useManagerActualExpense = () => {
    const dispatch = useDispatch();
    const { employees } = useSelector((state) => state.employees);
    const { quotations } = useSelector((state) => state.hourlyRateQuotation);
    const { projectTrackingWorkEntries } = useSelector(
        (state) => state.workentries
    );
    const { hardwareProjectTracking } = useSelector(
        (state) => state.hardwareDescription
    );
    const { descriptionProjectTracking } = useSelector(
        (state) => state.descriptionTasks
    );
    const { projects } = useSelector((state) => state.projects);
    const email = localStorage.getItem("email")
    const { leads } = useSelector((state) => state.leads);

    const [quotationProjectsdata, setquotationProjects] = useState([]);
    const [groupedProjects, setGroupedProjects] = useState([]);
    const [combinedProjects, setCombinedProjects] = useState([]);
    const [mergedProjects, setMergedProjects] = useState([]);
    const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);
    const [financeDataProject, setfinanceDataProject] = useState([]);


    useEffect(() => {
        dispatch(fetchWorkEntriesProjectTracking());
        dispatch(fetchDescriptionTasksProjectTracking());
        dispatch(fetchHardwareProjectTracking());
        dispatch(fetchEmployees());
        dispatch(fetchSalesHourlyRates());
        dispatch(fetchEmployees());
        dispatch(fetchWorkEntries());
        dispatch(fetchAllProjects());
        dispatch(fetchQuotations());
        dispatch(fetchOtherExpenses());
        dispatch(fetchSalesTaxes());
        dispatch(fetchLeads())
    }, [dispatch]);

    useEffect(() => {
        const filteredProject = projects.filter(
            (proj) => proj.isProjecttracking === true
        );

        const qualifiedGroups = filteredProject.filter((project) => {
            // Must have at least one assigned person
            if (!project?.Assignedperson?.length) return false;

            return project.Assignedperson.every((person) =>
            (
                person.salespersonstatus === "project ongoing" ||
                person.salespersonstatus === "project complete"
            )
            );
        });

        const emailFilteredGroups = qualifiedGroups.filter((project) => {
            if (!project?.AssignedManagerEmail?.includes(email)) return false;

            const currentEmployee = (employees || []).find(
                (emp) =>
                    emp.EmpEmail?.trim().toLowerCase() ===
                    email?.trim().toLowerCase()
            );
            const loggedManagerId = resolveEntityId(currentEmployee?._id);
            if (loggedManagerId) {
                const rowManagerId = String(
                    project.managerid || project.managerId || ""
                ).trim();
                if (rowManagerId && rowManagerId !== loggedManagerId) {
                    return false;
                }
            }
            return true;
        });
        console.log("sdfsfs emailFilteredGroups", emailFilteredGroups)

        setfinanceDataProject(emailFilteredGroups)
    }, [projects, email, employees]);


    const getProjQuotationId = (p) => p?.quotationId ?? p?.QuotationId ?? p?.ProjectName;

    useEffect(() => {
        if (!leads || !financeDataProject) return; // guard

        // Find projects that have a match (by quotationId so same ProjectName keeps separate actual data)
        const matchedProjects = financeDataProject.filter((row) =>
            leads.some((proj) => getProjQuotationId(proj) === getProjQuotationId(row))
        );

        setSearchedCalcProjects(matchedProjects);
    }, [leads, financeDataProject]);

    useEffect(() => {
        if (!searchedCalcProjects) return;

        const newData = searchedCalcProjects.map((proj) => {
            const projectIds = collectManagerReassignmentProjectIds(proj, projects);
            const projectIdSet = new Set(projectIds);

            const matchedEntries = projectTrackingWorkEntries.filter((entry) =>
                projectIdSet.has(String(entry.projectid))
            );

            const matchedDescriptions = descriptionProjectTracking.filter(
                (task) => projectIdSet.has(String(task.projectid))
            );

            const matchedHardware = hardwareProjectTracking.filter((task) =>
                projectIdSet.has(String(task.projectid))
            );

            return {
                ProjectName: proj.ProjectName,
                quotationId: getProjQuotationId(proj),
                TaskList: matchedEntries,
                Description: matchedDescriptions,
                TypeService: proj.TypeService,
                HardwareList: matchedHardware,
                Assignedperson: proj.Assignedperson,
                SalesPersonEmail: proj.SalesPersonEmail,
            };
        });

        setMergedProjects(newData);
    }, [searchedCalcProjects, projectTrackingWorkEntries, descriptionProjectTracking, hardwareProjectTracking, projects]);

    useEffect(() => {
        if (!mergedProjects || mergedProjects.length === 0) return;

        const qId = (p) => p.quotationId ?? getProjQuotationId(p);
        const grouped = Object.values(
            mergedProjects.reduce((acc, project) => {
                const id = qId(project);
                if (!acc[id]) {
                    acc[id] = {
                        ProjectName: project.ProjectName,
                        quotationId: id,
                        salespersonEmail: project.SalesPersonEmail,
                        TaskList: [],
                        Description: [],
                        HardwareList: [],
                    };
                }
                acc[id].TaskList.push(...(project.TaskList || []));
                acc[id].Description.push(...(project.Description || []));
                acc[id].HardwareList.push(...(project.HardwareList || []));
                return acc;
            }, {})
        );

        setCombinedProjects(grouped);
    }, [mergedProjects]);
    useEffect(() => {
        if (!combinedProjects?.length || !employees?.length) return;

        const updatedProjects = combinedProjects.map((project) => {
            const enrichWithDesignation = (arr = []) =>
                arr.map((item) => {
                    // Prefer taskownerid first
                    const emp =
                        employees.find((e) => e._id === item.taskownerid) ||
                        employees.find((e) => e._id === item.createdBy);

                    if (emp) {
                        // Only include designation if servicetype or customRoles exist
                        const designationParts = [];
                        if (emp.servicetype) designationParts.push(emp.servicetype);
                        if (emp.customRoles?.length) designationParts.push(emp.customRoles[0]);

                        return {
                            ...item,
                            designation: designationParts.join(" ").trim() || null,
                        };
                    }

                    return { ...item, designation: null };
                });

            return {
                ...project,
                Description: enrichWithDesignation(project.Description),
                TaskList: enrichWithDesignation(project.TaskList),
                HardwareList: enrichWithDesignation(project.HardwareList),
            };
        });

        setGroupedProjects(updatedProjects);
    }, [combinedProjects, employees]);

    useEffect(() => {
        if (!groupedProjects || !quotations || !employees) return;

        const currentEmployee = employees.find(
            (emp) =>
                emp.EmpEmail?.trim().toLowerCase() === email?.trim().toLowerCase()
        );
        const managerRatesOwnerId = resolveEntityId(currentEmployee?._id);
        if (!managerRatesOwnerId) return;

        const updatedProjects = groupedProjects.map((project) => {
            const enrichWithQuotation = (arr) =>
                arr.map((item) => {
                    if (!item.designation) {
                        return {
                            ...item,
                            hourlysalaray: item.hourlysalaray || 0,
                            overheadpercentage: item.overheadpercentage || 0,
                        };
                    }

                    const matchedQuote = quotations.find(
                        (q) =>
                            q.designation === item.designation &&
                            String(q.personid || "") ===
                                String(item.taskownerid || "") &&
                            resolveEntityId(q.createdBy) === managerRatesOwnerId
                    );
                    const hourlysalaray =
                        (item.hourlysalaray ?? matchedQuote?.hourlysalaray ?? 0) ||
                        0;
                    const overheadpercentage =
                        (item.overheadpercentage ??
                            matchedQuote?.overheadpercentage ??
                            0) || 0;

                    return {
                        ...item,
                        hourlysalaray,
                        overheadpercentage,
                    };
                });

            return {
                ...project,
                TaskList: project.TaskList ? enrichWithQuotation(project.TaskList) : [],
                Description: project.Description
                    ? enrichWithQuotation(project.Description)
                    : [],
                HardwareList: project.HardwareList
                    ? enrichWithQuotation(project.HardwareList)
                    : [],
            };
        });

        setquotationProjects(updatedProjects);
    }, [groupedProjects, quotations, employees, email]);

    return quotationProjectsdata;
};